import { render, staticRenderFns } from "./CollapseTransition.vue?vue&type=template&id=4a1526dd&scoped=true"
import script from "./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue?vue&type=script&lang=js"
import style0 from "./CollapseTransition.vue?vue&type=style&index=0&id=4a1526dd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1526dd",
  null
  
)

export default component.exports